import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaGithub, FaChevronDown } from "react-icons/fa";
import "./Navbar.css";

function NavbarMobile() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    if (!menuOpen) return;
    const handleKey = (e) => { if (e.key === "Escape") closeMenu(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [menuOpen, closeMenu]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/energy", label: "Energy" },
    { to: "/robotics", label: "Robotics" },
    { to: "/arctic", label: "Arctic" },
    { to: "/experience", label: "Contact" },
  ];

  return (
    <>
      {menuOpen && <div className="navbar-mobile-backdrop" onClick={closeMenu} />}
      <nav className="navbar-mobile">
        <div className="navbar-mobile-top">
          <div className="navbar-mobile-brand">
            <Link to="/" className="navbar-logo">
              <img src="/E.svg" alt="Logo" width="48" height="48" />
            </Link>
            <span className="navbar-mobile-name">Eugen Dunca</span>
          </div>
          <div className="navbar-mobile-social">
            <a href="https://instagram.com/edunca01" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com/in/eugen-dunca" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://github.com/edunca01" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
          </div>
        </div>
        <div className="navbar-mobile-nav">
          <button
            className="navbar-mobile-toggle"
            aria-label="Navigation Menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            Navigation
            <FaChevronDown className={`navbar-mobile-chevron ${menuOpen ? "navbar-mobile-chevron--open" : ""}`} />
          </button>
          <div
            className={`navbar-mobile-menu ${menuOpen ? "navbar-mobile-menu--open" : ""}`}
            aria-hidden={!menuOpen}
          >
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`navbar-mobile-link ${location.pathname === link.to ? "active" : ""}`}
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavbarMobile;
